import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  MenuItem,
  Paper,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { toast } from "sonner";
import { PageWrapper } from "../../../components/layout/PageWrapper";

export function SettingsPage() {
  const [settings, setSettings] = useState({
    portalName: "Spend2Connect",
    supportEmail: "support@spend2connect.co.zw",
    timezone: "Africa/Harare",
    currency: "USD",
    tokenExpiryDays: "30",
    failedLoginLimit: "5",
    auditRetentionDays: "180",
    requireStrongPasswords: true,
    notifyOnApiFailure: true,
  });

  const updateSetting = (name, value) => {
    setSettings((current) => ({ ...current, [name]: value }));
  };

  const saveSettings = (event) => {
    event.preventDefault();
    toast.success("Settings saved in the interface prototype.");
  };

  return (
    <PageWrapper>
      <Box
        component="form"
        onSubmit={saveSettings}
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", lg: "repeat(2, minmax(0, 1fr))" },
          gap: 1,
          alignItems: "start",
        }}
      >
        <Paper variant="outlined">
          <Box sx={{ minHeight: 44, px: 1.25, display: "flex", alignItems: "center" }}>
            <Box>
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 600 }}>
                Portal
              </Typography>
              <Typography color="text.secondary" sx={{ mt: 0.1, fontSize: "0.75rem" }}>
                General management settings
              </Typography>
            </Box>
          </Box>
          <Divider />
          <Stack spacing={1.25} sx={{ p: 1.5 }}>
            <TextField
              label="Portal name"
              value={settings.portalName}
              onChange={(event) => updateSetting("portalName", event.target.value)}
              fullWidth
            />
            <TextField
              label="Support email"
              type="email"
              value={settings.supportEmail}
              onChange={(event) => updateSetting("supportEmail", event.target.value)}
              fullWidth
            />
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
              <TextField
                label="Timezone"
                select
                value={settings.timezone}
                onChange={(event) => updateSetting("timezone", event.target.value)}
                fullWidth
              >
                <MenuItem value="Africa/Harare">Africa/Harare</MenuItem>
                <MenuItem value="Africa/Johannesburg">Africa/Johannesburg</MenuItem>
                <MenuItem value="UTC">UTC</MenuItem>
              </TextField>
              <TextField
                label="Currency"
                select
                value={settings.currency}
                onChange={(event) => updateSetting("currency", event.target.value)}
                fullWidth
              >
                <MenuItem value="USD">USD</MenuItem>
                <MenuItem value="ZAR">ZAR</MenuItem>
                <MenuItem value="ZWG">ZWG</MenuItem>
              </TextField>
            </Stack>
          </Stack>
        </Paper>

        <Paper variant="outlined">
          <Box sx={{ minHeight: 44, px: 1.25, display: "flex", alignItems: "center" }}>
            <Box>
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 600 }}>
                Security
              </Typography>
              <Typography color="text.secondary" sx={{ mt: 0.1, fontSize: "0.75rem" }}>
                Session and audit defaults
              </Typography>
            </Box>
          </Box>
          <Divider />
          <Stack spacing={1.25} sx={{ p: 1.5 }}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
              <TextField
                label="Token expiry (days)"
                type="number"
                value={settings.tokenExpiryDays}
                onChange={(event) => updateSetting("tokenExpiryDays", event.target.value)}
                fullWidth
              />
              <TextField
                label="Failed login limit"
                type="number"
                value={settings.failedLoginLimit}
                onChange={(event) => updateSetting("failedLoginLimit", event.target.value)}
                fullWidth
              />
            </Stack>
            <TextField
              label="Audit retention (days)"
              type="number"
              value={settings.auditRetentionDays}
              onChange={(event) => updateSetting("auditRetentionDays", event.target.value)}
              fullWidth
            />
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={settings.requireStrongPasswords}
                  onChange={(_, checked) => updateSetting("requireStrongPasswords", checked)}
                />
              }
              label="Require strong passwords"
              sx={{ m: 0, "& .MuiFormControlLabel-label": { fontSize: "0.8125rem" } }}
            />
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={settings.notifyOnApiFailure}
                  onChange={(_, checked) => updateSetting("notifyOnApiFailure", checked)}
                />
              }
              label="Notify administrators on API failures"
              sx={{ m: 0, "& .MuiFormControlLabel-label": { fontSize: "0.8125rem" } }}
            />
          </Stack>
        </Paper>

        <Paper
          variant="outlined"
          sx={{
            display: "flex",
            minHeight: 48,
            px: 1.25,
            gridColumn: { lg: "1 / -1" },
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Button type="submit" variant="contained" startIcon={<SaveOutlinedIcon />}>
            Save settings
          </Button>
        </Paper>
      </Box>
    </PageWrapper>
  );
}
